/**
 * Serverloos delen via een link: de gegevens zitten base64-gecodeerd in `?share=`.
 * Een ontvangen link wordt ALTIJD eerst gevalideerd (parseShare) en pas na bevestiging toegepast.
 */

export function encodeShare(value: unknown): string {
  return btoa(encodeURIComponent(JSON.stringify(value)));
}

/** Decodeert en valideert. `validate` geeft het veilige object terug, of undefined bij ongeldige gegevens. */
export function parseShare<T>(param: string, validate: (raw: unknown) => T | undefined): T | undefined {
  try {
    return validate(JSON.parse(decodeURIComponent(atob(param))));
  } catch {
    return undefined;
  }
}

export function buildShareUrl(value: unknown, base = window.location): string {
  return `${base.origin}${base.pathname}?share=${encodeShare(value)}`;
}

export type ShareResult = 'shared' | 'copied' | 'failed';

/** Native deeldialoog op mobiel, met terugval op het klembord. Annuleren door de gebruiker telt niet als fout. */
export async function shareOrCopy(data: { title: string; text: string; url: string }): Promise<ShareResult> {
  if (navigator.share) {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (e) {
      if (e instanceof DOMException && e.name === 'AbortError') return 'shared';
    }
  }
  try {
    await navigator.clipboard.writeText(`${data.text} ${data.url}`);
    return 'copied';
  } catch {
    return 'failed';
  }
}
